"use client"

export function WelcomePopup() {
  // const params = useSearchParams()
  // const router = useRouter()
  return null
  // return (
  //   <Modal isOpen={params?.get("welcome") === "true"} size="6xl" onClose={() => router.push("/")}>
  //     <div className="p-4">
  //       <iframe title=" " src="https://info.trendwatching.com/welcome" className="h-[calc(100vh-120px)] w-full rounded-lg" />
  //     </div>
  //   </Modal>
  // )
}
